import {
    GET_CONFIG_FORM23,
    OBTENER_LLAVES,
    GET_DATOS_GESTION,
    GET_COMBO_GESTION,
    POST_PROCESAR,
    GET_MONTOS
   
   
} from '../types';
export default function encargadoCompaniaReducer(state = {}, action) {
    switch (action.type) {
        case GET_CONFIG_FORM23:
            return { ...state, cfg_form23:action.payload }
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_DATOS_GESTION:
            return { ...state, datosGestionImplicado: action.payload }
        case GET_COMBO_GESTION:
            return { ...state, comboGestion: action.payload }
        case GET_MONTOS:
            return { ...state, montosInformados: action.payload }
        case POST_PROCESAR:
            return { ...state, respuestaProcesar: action.payload }
           
        
       
       
        default:
            return state
    }
}